export default "__VITE_ASSET__CnhGCSTv__"